import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  unauthorizedErrorActions,
  useUnauthorizedErrorSelectors
} from '../../_store/slices/user/unauthorizedErrorSlice';

export function useUnauthorizedErrorHandler() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { hasError } = useUnauthorizedErrorSelectors();

  useEffect(() => {
    if (hasError) {
      dispatch(unauthorizedErrorActions.clear());
      navigate('/auth');
    }
  }, [dispatch, hasError, navigate]);
}
